import React, {ReactNode} from 'react';
import styles from './Lable.module.scss';

interface IProps {
    children: ReactNode;
    className?: string;
    fontSize?: number;
    color?: string;
}

const Label: React.FC<IProps> = (props: IProps) => {
    const {
        className = '',
    } = props;
    return (
        <label className={[styles.title, className].join(' ')}>
            {props.children}
        </label>
    );
};

export default Label;
